import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-4da23725"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    id: "services-section",
    class: "services"
};
const _hoisted_2 = { class: "site-container" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("header", { class: "services-intro" }, [
    /*#__PURE__*/ _createElementVNode("div", null, [
        /*#__PURE__*/ _createElementVNode("p", { class: "section-kicker" }, "Servicios"),
        /*#__PURE__*/ _createElementVNode("h2", null, "Una solución para cada etapa.")
    ]),
    /*#__PURE__*/ _createElementVNode("p", null, " Desde una certificación puntual hasta una operación patrimonial compleja, cada asunto recibe atención directa y una explicación simple. ")
], -1));
const _hoisted_4 = { class: "services-list" };
import ServiceCard from '@/components/ServiceCard.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ServicesSection',
    setup(__props) {
        const services = [
            {
                title: 'Compraventas e inmuebles',
                description: 'Estudio de títulos, promesas, compraventas, hipotecas y documentación inmobiliaria.',
                tag: 'Patrimonio',
            },
            {
                title: 'Certificaciones y legalizaciones',
                description: 'Firmas, documentos, testimonios notariales y demás actuaciones requeridas.',
                tag: 'Documentos',
            },
            {
                title: 'Sucesiones y testamentos',
                description: 'Planificación, trámites sucesorios, particiones y disposiciones testamentarias.',
                tag: 'Familia',
            },
            {
                title: 'Sociedades y empresas',
                description: 'Constitución, reformas, poderes y documentación para emprendimientos y empresas.',
                tag: 'Empresas',
            },
            {
                title: 'Poderes y contratos',
                description: 'Redacción y otorgamiento de poderes, contratos y acuerdos para cada situación.',
                tag: 'Gestiones',
            },
            {
                title: 'Familia y autorizaciones',
                description: 'Autorizaciones de viaje, permisos de menores y otras gestiones familiares.',
                tag: 'Personas',
            },
        ];
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _hoisted_3,
                    _createElementVNode("div", _hoisted_4, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(services, (service, index) => {
                            return _createVNode(ServiceCard, {
                                key: service.title,
                                number: String(index + 1).padStart(2, '0'),
                                title: service.title,
                                description: service.description,
                                tag: service.tag
                            }, null, 8, ["number", "title", "description", "tag"]);
                        }), 64))
                    ])
                ])
            ]));
        };
    }
});
